import type { Schedule, ScheduleDetailResponse, ScheduleEntry } from '@/features/fixedAssets/types'

// Prepaid schedules share the same server-side table as fixed-asset
// depreciation; the only difference is `schedule_type: 'prepaid'` and a
// simpler params shape (no method / useful life / residual).
export type PrepaidSchedule = Schedule
export type PrepaidEntry = ScheduleEntry
export type PrepaidDetailResponse = ScheduleDetailResponse

export const PREPAID_CATEGORIES = [
  'Insurance',
  'Rent',
  'Software Licenses',
  'Maintenance Contracts',
  'Subscriptions',
  'Advertising',
  'Other',
] as const

export type CreatePrepaidPayload = {
  schedule_type: 'prepaid'
  description: string
  category: string
  initial_amount: number
  start_date: string
  purchase_date: string | null
  duration_periods: number
  params: Record<string, never>
  debit_account: string
  credit_account: string
  third_account: null
  entries: PrepaidEntry[]
}
